import { Vector3 } from 'three'

/** 立方体当前世界位置的全局 ref，供 HandTracker / DropBox 读取 */
export const cubeWorldPosRef: { current: Vector3 } = { current: new Vector3() }
